module.exports = __webpack_public_path__ + "193f650967cbaa4c81f377fdd8fb40a4.png";